import { Template } from './interfaces';
import { MacrosInput, MacrosType } from '@ax/service';

export const toMacrosServicePayload = (template: Template): MacrosInput => {
  return {
    id: template.id,
    providerId: template.providerId ? template.providerId : '',
    type: MacrosType.PROVIDER,
    name: template.name || '',
    content: template.content ? template.content : '',
    section: template.noteSection ? template.noteSection : '',
    attributes: [
      { key: 'voice_trigger', value: template.voiceTrigger || '' },
      { key: 'note_section', value: template.noteSection || '' },
      { key: 'age', value: template.age || 'All' },
      { key: 'gender', value: template.gender || '' },
      { key: 'title', value: template.title || '' },
    ],
  };
};

export const fromMacrosServiceResponse = (macros: MacrosInput): Template => {
  const attributesMap = new Map(macros.attributes.map((obj) => [obj.key, obj.value]));
  return {
    id: macros.id,
    name: macros.name,
    content: macros.content,
    providerId: macros.providerId,
    title: attributesMap.get('title') || macros.name,
    voiceTrigger: attributesMap.get('voice_trigger'),
    noteSection: attributesMap.get('note_section'),
    age: attributesMap.get('age'),
    gender: attributesMap.get('gender'),
  };
};
